import React, { useEffect } from 'react';
import {
  Form,
  FormInstance,
  SelectBooleanInput,
  NumberInput
} from 'blueprint-form';
import { Row, Col } from '../../../../grid';
import { CardBlock } from '../../../organisms/card';

interface EpxSubAbuseSettingsData {
  alerts?: boolean;
  slips?: number;
  slipLikelihood?: number;
}

const DefaultSettings: EpxSubAbuseSettingsData = {
  alerts: true,
  slips: 2,
  slipLikelihood: 6
};

interface EpxSubAbuseSettingsProps {
  setForm?: (form: FormInstance<EpxSubAbuseSettingsData>) => void;
  onSubmit?: (data: EpxSubAbuseSettingsData) => void;
  disabled?: boolean;
}

const EpxSubAbuseSettings = ({
  setForm,
  onSubmit: _onSubmit,
  disabled
}: EpxSubAbuseSettingsProps): JSX.Element => {
  const form = new FormInstance<EpxSubAbuseSettingsData>(DefaultSettings);
  useEffect(() => {
    if (setForm) {
      setForm(form);
    }
  }, []);
  const onChange = (data: EpxSubAbuseSettingsData): void => {
    form.setData(data);
  };
  const onSubmit = (data: EpxSubAbuseSettingsData): void => {
    _onSubmit(data);
  };
  return (
    <CardBlock bare>
      <Form form={form} onChange={onChange} onSubmit={onSubmit}>
        <CardBlock>
          <Row>
            <Col sm={12}>
              <SelectBooleanInput
                label="Enable Alerts for Patient"
                name="alerts"
                fill
                disabled={disabled}
              />
            </Col>
          </Row>
          <Row>
            <Col sm={12}>
              <NumberInput
                label="Max. Uses per Timeframe"
                name="slips"
                min={1}
                required
                fill
                disabled={disabled}
              />
            </Col>
          </Row>
        </CardBlock>
      </Form>
    </CardBlock>
  );
};

export default EpxSubAbuseSettings;
